import { connect } from 'react-redux';
import ShowChanges from './showChanges'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) {
	return {
        actualPanel: state.panel.actualPanel,
        visitorTerritory: state.profile.visitorTerritory,
        isLoading: state.request.isLoading || state.panelChange.isLoading,
        isRemovingRequest: state.request.isRemoving,
        isRemovingPanelChange: state.panelChange.isRemoving,
        requests: state.request.requests.filter( pc => !pc.isProcessed),
        oldRequests: state.request.requests.filter( pc => pc.isProcessed),
        panelChanges: state.panelChange.panelChanges.filter( pc => !pc.isProcessed),
        oldPanelChanges: state.panelChange.panelChanges.filter( pc => pc.isProcessed),
        error: state.request.error
}};

function mapDispatchToProps(dispatch) {
    return({
        fetchRequests: (visitorTerritory) => { dispatch(AC.RequestsLoadingStarted(visitorTerritory) ) },
        fetchPanelChanges: (visitorTerritory) => { dispatch(AC.PanelChangesLoadingStarted(visitorTerritory) ) },
        removeRequest: (requestId) => { dispatch(AC.RequestRemovingStarted(requestId) ) },
        removePanelChange: (panelChangeId) => { dispatch(AC.PanelChangeRemovingStarted(panelChangeId) ) },
        fetchPanel: (visitorTerritory) => { dispatch(AC.PanelLoadingStarted(visitorTerritory) ) },
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowChanges);